import React, { CSSProperties } from 'react';

import { container } from './video.module.scss';

interface VideoProps {
  style?: CSSProperties;
  category?: string;
  youtubeId: string;
  title: string;
}

function Video(props: VideoProps): JSX.Element {
  const { title, youtubeId, style } = props;

  return (
    <div className={container} style={style}>
      <iframe
        title={title}
        src={`https://www.youtube.com/embed/${youtubeId}`}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
}

export default React.memo(Video);
